import React, { HTMLProps } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import styles from './ApiError.module.scss';

import { ReactComponent as ApiErrorIcon } from './apiErrorIcon.svg';
import { useTranslation } from 'react-i18next';

export const apiErrorTestId = 'apiErrorTestId';

export interface ApiErrorProps extends HTMLProps<HTMLDivElement> {
  readonly className?: string;
  readonly text?: string;
}

export const ApiError = (props: ApiErrorProps) => {
  const { className, text, ...rest } = props;
  const { t } = useTranslation('task');

  return (
    <div
      className={clsx(styles.apiError, className)}
      data-testid={apiErrorTestId}
      {...rest}
    >
      <ApiErrorIcon className={styles.errorIcon} />
      <div className={styles.textHead}>
        <FontAwesomeIcon icon={faExclamationCircle} />
        {t('Something went wrong')}
      </div>
      <div className={styles.text}>
        {text ||
          t(
            'We are experiencing an internal server problem, please try again later'
          )}
      </div>
    </div>
  );
};
